<template>
  <div class="p-4 bg-blue-100  rounded shadow overflow-hidden">
    <header class="border-b border-blue-200 pb-2 items-center">
      <h2 class="font-bold leading-6 text-blue-900">Have an access code?</h2>
    </header>
    <!-- eslint-disable-next-line max-len -->
    <p class="mt-2 text-sm text-blue-800 leading-tight">Have you been given a code to provide you with free trial access to one of our online services? If so, please enter it below.</p>
    <activate-code-form />
  </div>
</template>

<script>
import ActivateCodeForm from '@/app/modules/home/components/activate-code/activate-code-form.vue';

export default {
  name: 'activate-code',
  components: {
    ActivateCodeForm,
  },
};
</script>
